var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemTypeIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0377 2.17064C14.1927 1.41584 13.0944 1 11.9452 1C10.6753 1 9.45364 1.51736 8.59238 2.4204L2.51313 8.81305C1.00484 10.614 1.20194 13.2565 2.96219 14.8294C3.80721 15.5842 4.90594 16 6.05515 16C7.32421 16 8.54629 15.4826 9.40754 14.58L15.4864 8.18738C16.9951 6.38597 16.7984 3.7431 15.0377 2.17064ZM8.66481 13.9182C7.99495 14.6204 7.04371 15.0235 6.05559 15.0235C5.16054 15.0235 4.30543 14.6998 3.64742 14.1119C2.27697 12.8874 2.12377 10.8302 3.27737 9.45146L6.0534 6.53293L11.2635 11.1866L8.66481 13.9182ZM14.7221 7.54896L11.9465 10.4679L6.73643 5.81424L9.33424 3.0826C10.0045 2.38005 10.9558 1.97695 11.9448 1.97695C12.8394 1.97695 13.6945 2.30062 14.3521 2.88849C15.723 4.11222 15.8766 6.16976 14.7221 7.54896Z",
    fill: "#737373",
    stroke: "",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTypeIcon4);
export default __webpack_public_path__ + "static/media/item-type-icon4.a42d46db5b95cbf4d4a2f95237829a54.svg";
export { ForwardRef as ReactComponent };